<template>
  <v-container grid-list-lg pa-0 :class="{ blured: !isConnected && user.role === 'agent' }">
    <vue-perfect-scrollbar class="chat-list-container" ref="scrollList" :settings="settings" @ps-y-reach-end.stop="searchChats">
      <v-container grid-list-lg fluid class="chat-list-content">
        <v-layout row wrap v-if="chats.length > 0">
          <v-flex xs3 v-for="(chat, index) in chats" :key="`chat-${index}`">
            <chat-card :chat="chat" :channels="channelList" @click.native="openChat(chat.id)">
            </chat-card>
          </v-flex>
          <template v-if="chats.length > 0 && isSearching">
            <v-flex xs3 v-for="index in (chats.length % 4 == 0 ? 4 : (4 - chats.length % 4) + 4)" :key="`skeletonm${index}`">
              <skeleton :index="index">
              </skeleton>
            </v-flex>
          </template>
        </v-layout>
        <v-layout row wrap v-else-if="isSearching && !chats.length">
          <v-flex xs3 v-for="index in 12" :key="`skeletonm${index}`">
            <skeleton :index="index">
            </skeleton>
          </v-flex>
        </v-layout>
        <info v-else>
          No se encontraron chats
        </info>
      </v-container>
    </vue-perfect-scrollbar>
  </v-container>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Info from '@/components/global/Info';
import Skeleton from './CardSkeleton';
import ChatCard from './ChatCard';

export default {
  components: {
    VuePerfectScrollbar,
    Skeleton,
    ChatCard,
    Info,
  },
  props: {
    isConnected: {
      type: Boolean,
      default: false,
    },
    isSearching: {
      type: Boolean,
      default: false,
    },
    stopScrolling: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
    chats: {
      type: Array,
      default: () => [],
    },
    channelList: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 12,
    },
  },
  data() {
    return {
      settings: {
        suppressScrollX: true,
      },
    };
  },
  methods: {
    openChat(id) {
      this.$emit('open-chat', id);
    },
    searchChats() {
      if (this.chats.length &&
        this.chats.length >= this.limit && !this.stopScrolling && !this.isSearching) {
        this.$emit('search-chats');
      }
    },
  },
};
</script>

<style>
  .chat-list-container {
    height: calc(100vh - 170px);
  }
</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/ChatList.vue